module.exports = "https://www.gc-qa.gnp.com.mx/e7a19fa26d38cceedecc8bc1179f9052.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-dowload.svg
// module id = 166
// module chunks = 0